<div id="section" class="row">
  <label class="inline"
    >{{ labelName }} <span *ngIf="isRequired" class="required">*</span></label
  ><br />
  <div class="col-md-12 file-input-container">
    <div class="fileinput fileinput-new input-group" data-provides="fileinput">
      <span
        class="input-group-addon btn btn-default btn-file"
        [ngClass]="{ 'btn-error': submitted && isRequired && !isValid }"
      >
        <input
          class="custom-file-input"
          type="file"
          name="..."
          (change)="onFileChange($event)"
          #fileInput
          [disabled]="isDisabled"
        />
        <a
          href="javascript:void(0)"
          (click)="
            fileInput.value = ''; onFileChange(null); onRemoveFile(index)
          "
          class="btn-remove"
          data-dismiss="fileinput"
          >x</a
        >
      </span>
    </div>
  </div>
</div>
<div *ngIf="submitted && isRequired && !isValid" class="required">
  Document is required
</div>
